import React, { useState } from "react";
import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import getAmountLabel from "../../utils/getAmountLabel";
import dictionary from "../../utils/dictionary";

const acceptableLanguages = ["en", "fr", "es"];

const CARD_ELEMENT_OPTIONS = {
	style: {
		base: {
			color: "#32325d",
			fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
			fontSmoothing: "antialiased",
			fontSize: "16px",
			"::placeholder": {
				color: "#aab7c4",
			},
		},
		invalid: {
			color: "#fa755a",
			iconColor: "#fa755a",
		},
	},
};

const useStyles = makeStyles({
	root: (props) => ({
		background: props.background,
		transition: "none",
		border: 0,
		borderRadius: 4,
		color: "white",
		height: 40,
		padding: "0 30px",
		textTransform: "none",
		fontSize: "16px",
		marginTop: "20px",
		fontWeight: "normal",
		"&:hover": {
			background: props.background,
		},
	}),
});

const CheckoutForm = ({
	amount,
	currency,
	brandColor,
	clientSecret,
	disabled,
	onCheckoutSubmit,
	language,
}) => {
	// set checkout form button color
	const props = { background: brandColor || "#3D4050" };
	const classes = useStyles(props);

	const [error, setError] = useState(null);
	const [success, setSuccess] = useState(null);
	const stripe = useStripe();

	const elements = useElements();

	const { paymentSuccessTitle, paymentSuccessBody, pay } = dictionary[
		acceptableLanguages.includes(language) ? language : "en"
	];

	// Handle real-time validation errors from the card Element.
	const handleChange = (event) => {
		if (event.error) {
			setError(event.error.message);
		} else {
			setError(null);
		}
	};

	// Handle form submission for the card element
	const handleSubmit = async (event) => {
		event.preventDefault();
		const card = elements.getElement(CardElement);

		// save the payment method to the customer
		const result = await stripe.confirmCardPayment(clientSecret, {
			payment_method: { card },
			save_payment_method: true,
		});

		if (result.error) {
			// Inform the user if there was an error.
			setError(result.error.message);
			setSuccess(null);
		} else {
			setError(null);
			// payment request succeeded
			if (result.paymentIntent.status === "succeeded") {
				setSuccess(true);
				onCheckoutSubmit({
					success: true,
					message: paymentSuccessTitle + paymentSuccessBody,
				});
			}
		}
	};

	if (success) {
		return <div />;
	}

	return (
		<form onSubmit={handleSubmit}>
			<div style={{ margin: "10px" }}>
				<CardElement
					id="card-element"
					options={CARD_ELEMENT_OPTIONS}
					handleChange={handleChange}
				/>
			</div>
			<div
				className="card-errors"
				role="alert"
				style={{ marginTop: "10px", color: "#c23d4b" }}
			>
				{error}
			</div>

			<div>
				<Button
					variant="contained"
					fullWidth
					className={classes.root}
					type="submit"
					disabled={disabled}
					disableElevation
				>
					{pay} {getAmountLabel({ amount, currency })}
				</Button>
			</div>
		</form>
	);
};

export default CheckoutForm;



// WEBPACK FOOTER //
// ./src/components/payments/CreditCardForm.js